/**
 * Normalización de texto para las búsquedas que se resuelven en el navegador.
 *
 * El buscador de la memoria lo usa un equipo que escribe en español: "Martín", "Rodríguez",
 * "presupuesto máximo". Comparar con `toLowerCase()` a secas hace que buscar «martin» NO encuentre
 * «Martín» — y como el hecho existe y está a la vista, se lee como que el buscador está roto.
 *
 * `normalize('NFD')` descompone cada letra acentuada en letra + marca diacrítica, y el replace
 * borra las marcas. Es exactamente lo que hace `strip_accents_lower` del backend
 * (`utils/text_search.py`), que es quien rankea la búsqueda del agente: las dos superficies
 * normalizan igual, así que "lo que encuentro yo" y "lo que encuentra la IA" no divergen.
 */

const DIACRITICS = /\p{Diacritic}/gu;

/** Minúsculas + sin acentos. `null`/`undefined` → cadena vacía (nunca lanza). */
export function normalizeText(value) {
    if (value === null || value === undefined) return '';
    return String(value).normalize('NFD').replace(DIACRITICS, '').toLowerCase();
}

/**
 * ¿`haystack` contiene `needle`, ignorando acentos y mayúsculas?
 * Una aguja vacía matchea todo (es "sin filtro", no "no matchea nada").
 */
export function textIncludes(haystack, needle) {
    const target = normalizeText(needle).trim();
    if (!target) return true;
    return normalizeText(haystack).includes(target);
}

export default normalizeText;
